/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Box, Container, GridItem, Grid} from '@chakra-ui/react'
import RecommendedProducts from '../../../components/recommended-products'
import CartSearch from './cart-search'
import CartTitle from './cart-title'
import useMultiSite from '../../../hooks/use-multi-site'
import InteractionStudioContent from '../../../components/interaction-studio/content'
import InteractionStudioRecommendedProducts from '../../../components/interaction-studio/recommended-products'
import PropTypes from 'prop-types'
import useBreakpoints from '../../../hooks/use-breakpoints'

const RecommendedProductsWrapper = ({children}) => (
    <GridItem
        minWidth={0}
        paddingTop={10}
        paddingBottom={12}
        paddingX={{base: 4, lg: 8}}
        className="is-app-cart-recommendation"
    >
        {children}
    </GridItem>
)
RecommendedProductsWrapper.propTypes = {
    children: PropTypes.node
}

const EmptyCart = ({onRecommendedProductClick}) => {
    const {site} = useMultiSite()
    const productsPerSlide = useBreakpoints({base: 2, lg: 3, '2xl': 4})

    return (
        <Box data-testid="sf-cart-empty" flex="1" backgroundColor="stokkeGray.bright">
            <Container variant="no-padding">
                <Grid
                    templateColumns={{base: '1fr', lg: 'minmax(0, 1fr) 25rem'}}
                    templateRows={{base: 'repeat(3, auto)', lg: 'repeat(2, auto)'}}
                    px={{base: 4, lg: 8}}
                    py={10}
                >
                    {/* cart */}
                    <GridItem>
                        <CartTitle />
                        <CartSearch />
                    </GridItem>

                    {/* sidebar */}
                    <GridItem colStart={{lg: 2}} rowStart={{lg: 1}} rowEnd={{lg: -1}} />

                    {/*to add personalized content to the empty basket page*/}
                    <InteractionStudioContent id="is-empty-basket-content">
                        <Box className="is-cms-empty-basket"></Box>
                    </InteractionStudioContent>

                    {/* Product Recommendations */}
                    <InteractionStudioRecommendedProducts id="is-empty-basket-recommendations">
                        <RecommendedProducts
                            wrapper={RecommendedProductsWrapper}
                            title={
                                <FormattedMessage
                                    defaultMessage="You may also like"
                                    id="recommended_products.title.you_may_also_like"
                                />
                            }
                            recommender={`recom_EmptyBasket_${site.id}`}
                            itemsPerSlide={productsPerSlide}
                            onRecommendedProductClick={onRecommendedProductClick}
                        />
                    </InteractionStudioRecommendedProducts>
                </Grid>
            </Container>
        </Box>
    )
}

EmptyCart.propTypes = {
    onRecommendedProductClick: PropTypes.func
}

export default EmptyCart
